import MassMediaCard from '../views/MassMediaCard.vue';
import News from '../views/News.vue';
import NewsCard from '../views/NewsCard.vue';

export const routes = [
  {
    path: '/media',
    name: 'News',
    component: News,
  },
  {
    path: '/media/edit/:typeId/:id',
    name: 'NewsCard',
    component: NewsCard,
  },
  {
    path: '/massMedia/:action/:id',
    name: 'MassMediaCard',
    component: MassMediaCard,
  },
];
